<div class="quick-search-item">
  <a target="_blank" (click)="displayNewPropertiesDialog(true)">Recently Imported Properties</a>
</div>

<div class="quick-search-item">
  <a target="_blank" (click)="displayRecentlyCompletedTasksDialog(true)">Recently Completed Tasks</a>
</div>

<div class="quick-search-item">
  <a href="{{getFavoritePropertiesSearchUri()}}">Favorite Properties</a>
</div>
